import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewChild } from '@angular/core';
import { CustomerSupportState } from './definition/customer-support.interface';
import { CustomerSupportService } from './customer-support.service';
import { ErrorMessage, Icons, ModalButtonId, RemovalSubmissionButton } from '../../services/shared/shared-enums';
import { KngLoaderState, ModalComponent, ModalEvent, ModalState } from 'kinetic-angular';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
	selector: 'tmhna-portal-app-customer-support',
	templateUrl: './template/customer-support.component.html',
	styleUrls: ['./template/customer-support.component.scss']
})
export class CustomerSupportComponent implements OnInit, OnDestroy
{

	constructor(public service: CustomerSupportService, public router: Router, public localStorageService: LocalStorageService) { }
	private readonly subscriptions: Subscription = new Subscription();
	@Input() showHr: boolean = true;
	@ViewChild('confirmSessionState') confirmSessionState!: ModalComponent;
	loaderState: KngLoaderState = {
		imagePath: Icons.loaderWhite
	};
	email: string = '';
	@Output() stateChanged: EventEmitter<CustomerSupportState> = new EventEmitter<CustomerSupportState>();
	@Input() set state(value: CustomerSupportState) 
	{
		this.service.updateState(value);
	}
	get state(): CustomerSupportState
	{
		return this.service.state;
	}
	get confirmSession(): ModalState 
	{
		return this.service.confirmSession;
	}

	ngOnInit(): void 
	{
		this.initSubscriptions();
		this.service.getCustomerSupportState();
		this.checkEmail();
		this.confirmSession.buttons[0].label = RemovalSubmissionButton.cancel;
		this.confirmSession.buttons[1].label = RemovalSubmissionButton.proceed;
		const redirectedUser = this.localStorageService.getRedirectedUser();
		if(redirectedUser)
		{
			this.service.startImpersonationSession(redirectedUser, true);
			this.localStorageService.removeRedirectedUser();
		}
	}

	private initSubscriptions(): void
	{
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
			(next: CustomerSupportState) => this.stateChanged.emit(next)
		);
		this.subscriptions.add(stateChangeSubs);
	}
	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}

	ngOnDestroy(): void 
	{
		this.destroySubscriptions();
	}
	async startSession()
	{
		this.handleValidation();
		if(this.state.isInvalid) return;
		this.service.validateImpersonationSession(this.email);
	}
	handleValidation()
	{
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (this.email.trim() === '' || this.email.length < 5 || this.email.length > 50 || !emailRegex.test(this.email))
		{
			this.state.isInvalid = true;
			this.state.emailErrorMessage = ErrorMessage.invalidEmailFormat;
		}
		else 
		{
			this.state.isInvalid = false;
			this.state.emailErrorMessage = '';
		}
	}
	confirmModalEvent(event: ModalEvent) 
	{
		if (event.cta.id === ModalButtonId.proceed) 
		{
			this.service.startImpersonationSession(this.email);
		}
		this.confirmSession.hidden = false;
		this.confirmSessionState.closePopup();
	}
	checkEmail()
	{
		this.state.isInvalid = false;
		if(this.email.trim() === '')
		{
			this.state.startCTA.disabled = true;
		}
		else
		{
			this.state.startCTA.disabled = false;
		}
	}
}
